import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { CountryStaticData, StaticData } from '../../../global/interfaces';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../../reducers';
import { selectCountryWiseStaticData, selectStaticData } from '../../../shared/layout/main.selectors';
import { selectAuthLoggedIn } from '../../auth/auth.selectors';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';


@Component({
  standalone: false,
  selector: 'dsp-contact-us',
  templateUrl: 'contact-us.component.html',
  styleUrls: ['contact-us.component.scss']
})
export class ContactUsComponent {
  @Input() showTitle = true;
  public staticData$: Observable<StaticData>;
  public staticDataLogin$: Observable<CountryStaticData[]>;
  public token$: Observable<Boolean>;
  public expandedIndex: number | null = null;
  // public staticDataLogin$;


  public constructor(
    private readonly store: Store<AppState>,
    public route: Router
  ) {
    this.staticData$ = this.store.pipe(select(selectStaticData));
    this.token$ = this.store.pipe(select(selectAuthLoggedIn), map(token => !!token
      && !this.route.url.includes('provision/login')));
    this.staticDataLogin$ = this.store.pipe(select(selectCountryWiseStaticData));
    // this.staticDataLogin$ = [{ countryFullName: 'india', data: { phone: '1234567890', email: 'njfeh@dsjhd' } }, { countryFullName: 'london', data: { phone: '0987654321', email: 'hhuhu@njdfje' } }]
  }

  public onExpandItem(index: number) {
    this.expandedIndex = this.expandedIndex === index ? null : index;
  }
}
